const state = {
	account: null
}
export default state